import { useQuery } from "react-query";

import type { ExtractFnReturnType, QueryConfig } from "@/lib/react-query";

import { fetchClient } from "@/lib/fetchClient";
import type { Organization } from "@/types/resources";

export async function getOrganization(): Promise<Organization> {
  const { data } = await fetchClient.GET("/organizations/me");
  if (!data) {
    throw new Error("failed to fetch organization me");
  }
  return data;
}

type QueryFnType = typeof getOrganization;

type UseOrganizationOptions = {
  organizationID: string;
  config?: QueryConfig<QueryFnType>;
};

export const useOrganization = ({
  organizationID,
  config,
}: UseOrganizationOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["organizations/me", organizationID],
    queryFn: () => getOrganization(),
  });
};
